import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TermsOfServicePage = () => {
    return (
        <>
          <Container sx={{ py: 4 }}>
            <Typography variant="h4" color="primary" gutterBottom>
              Terms of Service
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Effective Date: September 23, 2025
            </Typography>
            <Typography paragraph>
              These Terms of Service (“Terms”) govern your use of CCOO.ca. By accessing or using our website, you agree to be bound by these Terms.
            </Typography>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🛍️ Use of Our Site</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  CCOO.ca is a brand showcase and catalog. We do not process payments or ship products directly. All purchases are fulfilled through Amazon.ca.
                </Typography>
                <Typography paragraph>
                  You agree to use our site for lawful purposes only and not to engage in any activity that disrupts or harms our services or users.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">📦 Product Listings</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  Product descriptions, images, and links are provided for informational purposes. We strive for accuracy, but we cannot guarantee availability, pricing, or specifications on Amazon.ca.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔗 Third-Party Services</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  Our site contains links to Amazon.ca and other third-party platforms. We are not responsible for their content, policies, or transactions. Please review their terms separately.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔐 Intellectual Property</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  All content on CCOO.ca — including logos, text, graphics, and design — is owned by us or our partners and protected by copyright and trademark laws. You may not reproduce or use our content without permission.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">📬 Contact & Support</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  For questions or support, contact us at:
                </Typography>
                <Typography>
                  <Link href="mailto:support@ccoo.ca">support@ccoo.ca</Link>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔄 Changes to These Terms</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We may update these Terms from time to time. Changes will be posted on this page with a revised effective date. Continued use of our site means you accept the updated Terms.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Container>
        </>
    )
}
export default TermsOfServicePage;